import React, { useContext, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { AwsFileUrl, BASE_URL_STATIC } from '../../../../../config';
import { ApiContext } from '../../../UseContext/ApiCall';


const CnpCollagePopup = () => {

  const {
    loggedInUser,

    createNewPost,

    // ----- Text -----
    cnpText, setCnpText,
    
    // ----- Photo/Video -----
    cnpSelectedPhotoVideo, 
    
    // ----- Felling/Activity -----
    setShowCnpFeelingActivityPopup,
    setCnpFeelingActivityTab,
    cnpSelectedFeeling,
    cnpSelectedActivityCategory,
    cnpSelectedActivity,
    getFeelings,
    getActivities,
    
    // ----- Check in/Location -----
    cnpSelectedLocation, setCnpSelectedLocation,
    setShowCnpLocationPopup,
    
    
    // ----- Music -----
    setShowCnpSelectMusicPopup,
    cnpSelectedMusic, setCnpSelectedMusic,
    selectedMusicPlaying, setSelectedMusicPlaying,
    cnpMusics,
    getMusics,

    // ----- Tag -----
    setCnpTagAxis,
    showCnpTagsOnPhoto, setShowCnpTagsOnPhoto,
    setShowCnpTagPopup,
    handleRemoveTaggedUser,

    // ----- Text & Background -----
    cnpSelectedTextBackground,

    // ----- Collage -----
    showCnpCollagePopup, setShowCnpCollagePopup,
    setShowCnpAddCollageImagePopup,

    // ----- Advance Setting -----
    setShowCnpAdvanceSettingPopup,
    getCnpAdvanceSetting,

  } = useContext(ApiContext);


  // console.log('cnpSelectedPhotoVideo : ', cnpSelectedPhotoVideo);


  // ----- Feeling/Activity -----

  // handle click feeling/activity
  const handleClickFeelingActivity = () => {

    setShowCnpCollagePopup(false);
    setShowCnpFeelingActivityPopup(true);
    
    if(cnpSelectedActivityCategory._id) {
      setCnpFeelingActivityTab('activity');

      getActivities(cnpSelectedActivityCategory._id, '', 0);
    } else {
      setCnpFeelingActivityTab('feeling');

      getFeelings('', 0);
    };
  };


  // ----- Location -----

  // handle click location
  const handleClickLocation = () => {
    setShowCnpCollagePopup(false);
    setShowCnpLocationPopup(true);
  };


  // ----- Music -----

  const musicRef = useRef(new Audio());

  // handle click music
  const handleClickMusic = () => {
    setShowCnpCollagePopup(false);
    setShowCnpSelectMusicPopup(true);

    getMusics('', cnpMusics.length, 10);
  };

  // handle play/pause music
  const handlePlayPauseMusic = () => {
    if (selectedMusicPlaying) {
      musicRef.current.pause();
      setSelectedMusicPlaying(false);
    } else {
      musicRef.current.src = cnpSelectedMusic.audio;
      musicRef.current.play();
      setSelectedMusicPlaying(true);
    };
  };

  // handle remove music
  const handleRemoveMusic = () => {
    setCnpSelectedMusic({});

    musicRef.current.pause();
    
    setSelectedMusicPlaying(false);

    // show location image if location selected when user remove music
    if((cnpSelectedTextBackground === '') && (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)) {
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: true
      }));
    };
  };


  // ----- Tag -----

  // handle tag on photo
  const handleTagOnPhoto = (e, index) => {
    setShowCnpTagPopup(true);
  
    const img = e.target;
    const rect = img.getBoundingClientRect();
  
    const percentX = ((e.clientX - rect.left) / rect.width) * 100;
    const percentY = ((e.clientY - rect.top) / rect.height) * 100;
  
    setCnpTagAxis({ index, offsetX: percentX, offsetY: percentY });
  };
  
  // handle click photo tag icon
  const handleClickPhotoTagIcon = () => {
    setShowCnpTagsOnPhoto(!showCnpTagsOnPhoto);
  };

  
  // ----- text -----

  // handle text change
  const handleTextChange = (e) => {
    const { value } = e.target;

    setCnpText(value);
  };
  
  
  // handle post collage 
  const handlePostCollage = async () => {
    createNewPost('collage');
  };

  // handle click advance setting
  const handleClickAdvanceSetting = () => {
    setShowCnpCollagePopup(false);
    setShowCnpAdvanceSettingPopup(true);
    getCnpAdvanceSetting('photoVideo');
  };

  // handle close collage popup
  const handleCloseCollagePopup = () => {
    setShowCnpCollagePopup(false);
    setShowCnpAddCollageImagePopup(true);    
  };


  return (
    <Modal show={showCnpCollagePopup} onHide={handleCloseCollagePopup} centered backdrop="static" keyboard={false} className="main-modal" >
      <Modal.Header className="mb-3 pt-0" closeButton>
        <h5 className="flex-grow-1 text-center pt-3 mb-0">Collage</h5>
      </Modal.Header>

      <Modal.Body className="pt-1">
        {/* Profile, Name, Feeling, Activity & Check in/Location */}
        <>
          {
            loggedInUser 
            &&
            <div className='d-flex align-items-center gap-3'>
              {/* Profile */}
              <img src={loggedInUser.profileImg && loggedInUser.profileImg.imageId && AwsFileUrl+loggedInUser.profileImg.imageId} className='border rounded-circle' style={{ height: '45px', width: '45px' }} alt='profile' />

              <div>
                {/* Name, Feeling, Activity & Check in/Location */}
                <div>
                  {/* Name */}
                  <span className='fs-5'>{loggedInUser.fname} {loggedInUser.lname}</span> {' '}

                  {/* Feeling */}
                  <>
                    {
                      (cnpSelectedFeeling && cnpSelectedFeeling._id)
                      &&
                      <>
                        <span className='text-secondary'>is</span> {' feeling '}
                        {cnpSelectedFeeling.feelingName} {' '}
                        <img src={cnpSelectedFeeling.feelingIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                        {' '}
                      </>
                    }
                  </>

                  {/* Activity */}
                  <>
                    {
                      (cnpSelectedActivityCategory && cnpSelectedActivityCategory._id)
                      &&
                      (cnpSelectedActivity && cnpSelectedActivity._id)
                      &&
                      <>
                        <span className='text-secondary'>is</span> {' '}
                        {cnpSelectedActivityCategory.activityCategoryName} {' '}
                        <img src={cnpSelectedActivityCategory.activityCategoryIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                        {cnpSelectedActivity.activityName} {' '}
                        <img src={cnpSelectedActivity.activityIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                      </>
                    }
                  </>

                  {/* Check in/Location */}
                  <>
                    {
                      (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)
                      &&
                      <>
                        <span className='text-secondary'>at</span> {' '}
                        {cnpSelectedLocation.place.split(" ").slice(0, 5).join(" ")}
                        {cnpSelectedLocation.place.split(" ").length > 5 && "..."}
                      </>
                    }
                  </>
                </div>

                {/* Add Location */}
                <>
                  {
                    (cnpSelectedLocation.place === '' && cnpSelectedLocation.lat === null && cnpSelectedLocation.lng === null)
                    &&
                    <div className='cursor-pointer' onClick={handleClickLocation}>
                      <img src={`/images/icons/location-black.svg`} className='me-1' style={{ height: '15px', width: '15px' }} alt="location" />
                      <span>Add Location</span>
                    </div>
                  }
                </>
              </div>
            </div>
          }
        </>

        {/* Collage */}
        <>
          {
            (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 0 && cnpSelectedPhotoVideo[0].file && cnpSelectedPhotoVideo[0].file.name)
            &&
            <div className='border text-center rounded-4 bg-light my-3' style={{ height: '200px' }}>
              <div className='d-inline-block position-relative h-100'>
                <>
                  <img src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} className='border border-dark h-100' style={{ cursor: 'crosshair' }} onClick={(e) => handleTagOnPhoto(e, 0)} alt="photoVideo" />

                  {/* Tags */}
                  <>
                    {
                      (showCnpTagsOnPhoto && cnpSelectedPhotoVideo[0].tags && cnpSelectedPhotoVideo[0].tags.length > 0)
                      &&
                      cnpSelectedPhotoVideo[0].tags.map((tagValue, tagIndex) => (
                        <div className='position-absolute pt-1 px-2 bg-secondary rounded-2 d-flex align-items-center gap-2 text-white' key={tagIndex}
                          style={{ 
                            top: `${tagValue.offsetY}%`, 
                            left: `${tagValue.offsetX}%`, 
                            zIndex: `${tagIndex}`,
                            fontSize: '13px',
                            transform: 'translate(-50%, -0%)'
                          }} 
                        >
                          <span>{tagValue.userName}</span>
                          <span className='cursor-pointer' onClick={() => handleRemoveTaggedUser(0, tagIndex)}>✖</span>
                        </div>
                      ))
                    }
                  </>

                  {/* Tag Icon */}
                  <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickPhotoTagIcon}>
                    <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                  </div>
                </>
              </div>
            </div>
          }
        </>

        {/* Music text (jb music selected h lekin music image show nhi krna h tb ye show krna h) */}
        <>
          {
            (cnpSelectedMusic && cnpSelectedMusic.id && cnpSelectedMusic.id !== '')
            &&
            <div className='my-3 d-flex align-items-center gap-3'>
              <img src="/images/icons/music.svg" style={{ height: '17px', width: '17px' }} alt="music" />

              <span className='me-auto text-truncate'>{cnpSelectedMusic.name}</span>

              {/* Play/Pause */}
              <img src={selectedMusicPlaying ? "/images/icons/pause-circle.svg" : "/images/icons/play-circle.svg"} 
                className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handlePlayPauseMusic} alt='playPause'
              />

              {/* Remove */}
              <img src="/images/icons/close-circle.svg" className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handleRemoveMusic} alt="remove" />
            </div>
          }
        </>

        {/* text */}
        <textarea className="form-control rounded-4 my-3 shadow-none" name="text" style={{ resize: 'none' }} rows={3} 
          value={cnpText} onChange={handleTextChange} placeholder={`What's new ${loggedInUser && loggedInUser.fname}..?`}
        />

        {/* Menu */}
        <div className='d-flex flex-wrap gap-4'>
          <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickFeelingActivity}>
            <img src={`${BASE_URL_STATIC}/create-icon8.png`} style={{ height: '23px', width: '23px' }} alt="feeling/activity" />
            <small className="text-secondary">Feeling/Activity</small>
          </div>

          <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickLocation}>
            <img src={`${BASE_URL_STATIC}/create-icon9.png`} style={{ height: '23px', width: '23px' }} alt="Check In" />
            <small className="text-secondary">Check In</small>
          </div>

          <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickMusic}>
            <img src={`${BASE_URL_STATIC}/create-icon11.png`} style={{ height: '23px', width: '23px' }} alt="Music" />
            <small className="text-secondary">Music</small>
          </div>
        </div>

        <button type="button" className='btn btn-primary w-100 rounded-pill mt-3 mb-1' onClick={handlePostCollage} >Post</button>

        {/* Advance Setting */}
        <div className='text-center'>
          <span className='text-primary cursor-pointer' onClick={handleClickAdvanceSetting}>Advance Setting</span>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CnpCollagePopup;